const projects = {
    designed: [
        {
            id: 1,
            name: "Pronaos",
            imgSrc: "projects/pronaos.png",
            shortDescription: "USB-MIDI interface with an on-module semantic layer for generative rhythm.",
            description: "USB-MIDI interface with an on-module semantic layer. Incoming MIDI is passed through a small embedded model that generates rhythmic variations conditioned on a handful of general controls • density, swing, bias • then emits 0–4 V pitch CV and 0–5 V gate / trigger / clock across six routing modes. Inference runs entirely on the module.",
            specs: ["USB-MIDI", "CV 0-4V", "Gate 0-5V", "Generative"],
            aiTags: ["Generative AI", "AI-Built"],
            status: "Prototype"
        },
        {
            id: 2,
            name: "Gatekeeper",
            imgSrc: "projects/gatekeeper.png",
            shortDescription: "Low-noise I/O bridge between Eurorack and line-level gear.",
            description: "Low-noise audio bridge between Eurorack and line level. No processing on the signal path • a clean, transparent route for sending rack audio to outboard instruments or inference running off-module, and returning it without coloration.",
            specs: ["Audio I/O", "Low Noise", "Transparent Path"],
            aiTags: ["AI-Built"],
            status: "Prototype"
        },
        {
            id: 3,
            name: "Beetlejuice",
            imgSrc: "projects/beetlejuice.png",
            shortDescription: "Credit-card-sized PSU, designed end-to-end with AI assistance.",
            description: "Credit-card-sized PSU designed end-to-end with AI assistance • topology selection, component sizing, and layout review • before any of that was standard practice. +5 V at 4 A, +12 V at 3 A, and −12 V at 2 A from a single DC input, with dedicated filtering on each rail.",
            specs: ["+5V 4A", "+12V 3A", "-12V 2A", "AI-Designed"],
            aiTags: ["AI-Built"],
            status: "Production"
        }
    ],
    built: [
        {
            id: 1,
            name: "EuroPi",
            imgSrc: "projects/europi.png",
            shortDescription: "Allen Synthesis Pi Pico platform, used as a target for rhythmic ML models.",
            description: "An Allen Synthesis open-source module built around the Raspberry Pi Pico. In the lab, the Pico served as a target for small rhythmic ML models • its six CV outputs, two knobs, two buttons, digital and analog inputs, and OLED giving the model a full hands-on interface. Assembled and calibrated from the published design.",
            specs: ["Raspberry Pi Pico", "6 CV Out", "Rhythmic ML", "OLED"],
            status: "Open Source"
        },
        {
            id: 2,
            name: "Speaker",
            imgSrc: "projects/speaker.png",
            shortDescription: "Artist commission • compact in-rack monitoring.",
            description: "Built to order for an artist who needed compact monitoring inside their rack. A class-D amplifier and loudspeaker on a single Clacktronics panel, assembled and calibrated in the lab.",
            specs: ["Built-in Speaker", "Direct Monitor"],
            status: "Commission"
        },
        {
            id: 3,
            name: "Reverb",
            imgSrc: "projects/reverb.png",
            shortDescription: "Artist commission • Music Thing spring reverb, built to order.",
            description: "Built to order for an artist from Music Thing Modular's open spring-reverb design. Drives both electromechanical tanks and solid-state Belton-style units, with front-panel blend, feedback, and crossfader between dry and wet paths.",
            specs: ["Spring Reverb", "Blend", "Feedback", "Commission"],
            status: "Commission"
        }
    ]
};

export default projects;
